import * as types from '../mutation-type'
import * as localStorage from '../localStorage'

const state = localStorage.userInfo.get() || {
  uesr_datas: []
}

const getters = {
  user_datas: state => state.uesr_datas,
  isLoginByShowId: state => !!(state.uesr_datas && state.uesr_datas.is_login_by_show_id)
}

const mutations = {
  [types.SET_BASEINFO] (state, data) {
    try {
      state.uesr_datas = data
      state.time = localStorage.getDate()
      localStorage.userInfo.set(state)
    } catch (err) {
    }
  },
  [types.ADDTO_BASEINFO] (state, data) {
    try {
      state.uesr_datas = data
      localStorage.userInfo.set(state)
    } catch (err) {
    }
  },
  [types.CLEAR_BASEINFO] (state) {
    state.uesr_datas = ''
    localStorage.userInfo.set(state)
  }
}

const actions = {
  set_baseinfo ({commit}, param) {
    commit(types.SET_BASEINFO, param)
  },
  addto_baseinfo ({commit}, param) {
    commit(types.ADDTO_BASEINFO, param)
  },
  clear_baseinfo ({commit}) {
    commit(types.CLEAR_BASEINFO)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user_login.js